import React from 'react';
import { WithStyles, withStyles } from '@material-ui/core/styles/index';
import Button from '@material-ui/core/Button';
import createStyles from '@material-ui/core/styles/createStyles';

const styles = () => createStyles({
  root: {
    paddingTop: '0px',
    paddingBottom: '0px',
    marginLeft: '12px',
  },
});

interface Props extends WithStyles<typeof styles> {
  children?: any;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  variant?: string;
  color?: string;
  disabled?: boolean;
  classOverride?: any;
}

const ActionBarButton = (props: Props) => {
  const {
    classes, children, onClick, disabled, color, variant, classOverride, ...others
  } = props;
  const classToApply = classOverride || classes.root;
  // @ts-ignore
  return <Button size="small" variant={variant || 'text'} color={color || 'default'} className={classToApply} onClick={onClick} disabled={disabled} {...others}>{children}</Button>;
};

export default withStyles(styles)(ActionBarButton);
